let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("6vzdH"), load("gGI57"), load("lPCqB"), load("joJy8"), load("aHE9G"), load("iaptT")]).then(() => parcelRequire('hB4M9'));